// ABOUTME: The page's scroll lock, shared by every open modal: the first to open saves the page's own overflow,
// ABOUTME: the last to close gives it back — so a nested or later-mounted modal never unlocks the one under it.

let holders = 0
let saved: { overflow: string; paddingRight: string } | null = null

/**
 * Locks page scroll for one open modal and returns its release. Modals open and close in any order — a window
 * over a window, one mounted closed inside another — so the lock is a count, not a flag: only the last release
 * restores what the page had before the first lock.
 */
export const lockBodyScroll = (): (() => void) => {
  const { style } = document.body
  if (holders === 0) saved = { overflow: style.overflow, paddingRight: style.paddingRight }
  holders += 1
  style.overflow = "hidden"
  style.paddingRight = "0px"
  let released = false
  return () => {
    if (released) return
    released = true
    holders -= 1
    if (holders === 0 && saved) {
      style.overflow = saved.overflow
      style.paddingRight = saved.paddingRight
      saved = null
    }
  }
}
